import { render, staticRenderFns } from "./oldManFileSixth.vue?vue&type=template&id=281bec5e&scoped=true&"
import script from "./oldManFileSixth.vue?vue&type=script&lang=js&"
export * from "./oldManFileSixth.vue?vue&type=script&lang=js&"
import style0 from "./oldManFileSixth.vue?vue&type=style&index=0&id=281bec5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281bec5e",
  null
  
)

export default component.exports